import '../partials/component-carousel.js';
import '../partials/component-label.js';

export default {
  init() {
    // JavaScript to be fired on all pages

    /*
    ** Site Navigation
    */
    // Mobile - Main menu
    const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.burger-toggle'), 0);

    // Check if there are any navbar burgers
    if ($navbarBurgers.length > 0) {
        // Add a click event on each of them
        $navbarBurgers.forEach(function($el) {
            $el.addEventListener('click', function() {

                // Get the target from the "data-target" attribute
                const target = $el.dataset.target;
                const $target = document.getElementById(target);

                if ($target.classList.contains('is-active')) {
                    this.setAttribute('aria-expanded', 'false');
                    this.style.zIndex = '1';
                    $el.querySelector('.navbar-burger').classList.remove('is-active');
                    $target.classList.remove('is-active');
                } else {
                    this.setAttribute('aria-expanded', 'true');
                    this.style.zIndex = '9';
                    $el.querySelector('.navbar-burger').classList.add('is-active');
                    $target.classList.add('is-active');
                }
            });
        });
    }

    // Mobile - Dropdowns
    var menuItems = document.querySelectorAll('li.has-submenu');
    Array.prototype.forEach.call(menuItems, function(el) {
        var activatingA = el.querySelector('a.navbar-link');

        activatingA.addEventListener('click', function(event) {
            if (this.parentNode.classList.contains('open')) {
                this.parentNode.classList.remove('open');
                this.parentNode.querySelector('.navbar-dropdown').classList.add('is-hidden');
                this.setAttribute('aria-expanded', 'false');
            } else {
                this.parentNode.classList.add('open');
                this.parentNode.querySelector('.navbar-dropdown').classList.remove('is-hidden');
                this.setAttribute('aria-expanded', 'true');
            }
            event.preventDefault();
            return false;
        });
    });

    // Sticky Header
    $(window).scroll(function(){    
        $('nav ul li a').removeClass('active-nav');
        if ($(this).scrollTop() > 60){ 
            $('header').addClass('header-sticky');
            $('.headerMain .formStart').addClass('fadeInRight');
            $('header').css('position','sticky');

        }
        else{
            $('header').css('position','absolute');
            $('header').removeClass('header-sticky');
            $('.headerMain .formStart').removeClass('fadeInRight');
        }
    });

    // Modal Window
    $('.modal-btn').click(function() {
        $('html').addClass('is-clipped');
        $('.modal').addClass('is-active');
     });
     
     $('.modal-close').click(function() {
        $('html').removeClass('is-clipped');
        $('.modal').removeClass('is-active');
     });

     // Stop Video on close
     $(document).ready(function(){
        $('.modal').each(function(){
                var src = $(this).find('iframe').attr('src');
            $(this).on('click', function(){
                $(this).find('iframe').attr('src', '');
                $(this).find('iframe').attr('src', src);
            });
        });
    });

    // Number Inputs
    $(document).ready(function(){
        $('input.number, input.numberForm').keyup(function() {

            // skip for arrow keys
            if(event.which >= 37 && event.which <= 40) return;
        
            // format number
            $(this).val(function(index, value) {
            return value
            .replace(/\D/g, '')
            .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            });
        });

      // Remove comma in query string
        $('input.number, input.numberForm').on('change', function() {
            var numValue = $(this).val();
            numValue = numValue ? parseFloat(numValue.replace(/,/g, '')) : '';
            $(this).val(numValue);
          });

        $(window).bind('pageshow', function() {
            var form = $('form'); 
            // let the browser natively reset defaults
            for (var i = 0; i < form.length; i++) {
                form[i].reset();
                }
        });
    });

    // Query Parameter
   (function(window, document, $) {
    window.gotoSplitterId = function(id, params) {
        window.location.href = '/redirect/offers?id=' + id + '&' + $.param(params);
        return false;
        };
    })(window, document, jQuery);

        
    // Accordion Content Block
    let toggles = document.querySelectorAll('.block--accordion__faqToggle');
    for (let i = 0; i < toggles.length; i++) {
        toggles[i].addEventListener('click', function() {
            // Toggle plus and minus signs
            let el = this.firstElementChild;
            if (el.innerText == '+') {
                el.innerText = '-';
            } else {
                el.innerText = '+';
            }
            // Update aria-expanded label
            if (this.getAttribute('aria-expanded') == 'false') {
                this.setAttribute('aria-expanded', true);
            } else {
                this.setAttribute('aria-expanded', false);
            }
            // Display/hide content
            let contentEl = this.parentElement.parentElement.nextSibling.nextSibling;
            contentEl.classList.toggle('display');
        });
    }
  },

  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js